import {CustomTimeValue} from "./custom-time-value";

export class CustomFieldValue {
  competitorId?: number;
  fieldId?: number;
  boolValue?: boolean;
  numberValue?: number;
  inputString?: string;
  numberList?: number[];
  choiceList?: string[];
  dateValue?: Date;
  customTimeValue?: CustomTimeValue;
}
